import React from 'react';
import './create-new-catalogue.scss';
import {
  Link, Button,
} from '@material-ui/core';
import { SaleType } from 'api/query/catalogue';
import { useNavigation } from 'react-navi';
import { AddOutlinedIcon } from 'components/icons/add-outlined';
import { toQuerystring } from 'utils/navigation-utils';
import { CreateNewCatalogueProps } from './create-new-catalogue-props';

export const CreateNewCatalogue: React.FC<CreateNewCatalogueProps> = (props) => {
  const {
    type,
    db,
    trait,
    disabled,
  } = props;

  const navigation = useNavigation();
  const { search } = navigation.getCurrentValue().url;

  // creates link with db and trait from props if those doesn't exist in query
  let attr;
  const query = { db, scenario: trait };
  if (!search) {
    attr = toQuerystring(query);
  } else {
    attr = search;
  }

  const href = `/catalogue/create${attr}&type=${type}`;

  /**
   * Gets the button label by the sale type.
   * @param saleType
   */
  const getLabel = (saleType: SaleType) => {
    switch (saleType) {
      case SaleType.PrivateTreatySale:
      case SaleType.SingleVendorAuction:
        return 'SALE';
      case SaleType.AllSemenCatalogue:
        return 'SEMEN';
      default:
        throw Error('Invalid saleType');
    }
  };

  return (
    <div className="sg-create-new-catalogue">
      <Link
        className="sg-create-new-catalogue__link"
        href={disabled ? '#' : href}
        component="a"
      >
        <Button
          variant="outlined"
          className="sg-button"
          startIcon={<AddOutlinedIcon />}
          disabled={disabled}
        >
          {`NEW ${getLabel(type)} CATALOGUE`}
        </Button>
      </Link>
    </div>
  );
};
